
/*
 * 全局公用方法
 * author by leiyang	2018.06.05
 * */

export default{
    //ls : window.localStorage,
    //ss : window.sessionStorage,
    LStorage: {						//本地存储公用方法
    	getItem(key) {
		  try {
		   return JSON.parse(window.localStorage.getItem(key))
		  } catch (err) {
		   return null
		  }
		},
		 setItem(key, val) {
		  window.localStorage.setItem(key, JSON.stringify(val))
		},
		 clear() {
		  window.localStorage.clear()
		},
		 keys() {
		  return window.localStorage.keys()
		},
		 removeItem(key) {
		  window.localStorage.removeItem(key)
		}
    },
    SStorage: {
    	getItem(key) {
		  try {
		   return JSON.parse(window.sessionStorage.getItem(key))
		  } catch (err) {
		   return null
		  }
		 },
		 setItem(key, val) {
		  window.sessionStorage.setItem(key, JSON.stringify(val))
		 },
		 clear() {
		  window.sessionStorage.clear()
		 },
		 keys() {
		  return window.sessionStorage.keys()
		 },
		 removeItem(key) {
		  window.sessionStorage.removeItem(key)
		 }
    },
    base64ToData : (apiData) => {
		let base_to_json = Base64.decode(apiData)  //base64解密
		return base_to_json
	},
	
	DataToBase64 : (apiParm) => {
		let par_to_base = Base64.encode(apiParm)  //base64加密	
		return par_to_base
	},
	isPhone: (inputVal) => {
        var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if (!myreg.test(inputVal)) {
            return false;
        } else {
            return true;
      	}
	},
	sortStr: (str) =>{ 			//A->_a字符中的大写变下划线加小写输出
		let upper = {"a":"A","b":"B","c":"C","d":"D","e":"E","f":"F","g":"G","h":"H",
	    		"i":"I","j":"J","k":"K","l":"L","m":"M","n":"N","o":"O","p":"P", "q":"Q",
	        	"r":"R","s":"S","t":"T","u":"U","v":"V","w":"W","x":"X","y":"Y","z":"Z"}
	    for(var i in str){
	        for(var j in upper){
	            if(str[i]===upper[j]){
	            	if(str != 'weeklyAverage'){
	            		str=str.replace(str[i],'_'+j)
	            	}		                
	            }
	        }
	    }
	    return str;
	},
	getTimeArea: () =>{
		return new Date().getTimezoneOffset()/60
	},
	formatCycleTime: (timeName) =>{
		if(timeName == '00:00') timeName = '00:00 AM'
		if(timeName == '01:00') timeName = '01:00 AM'
		if(timeName == '02:00') timeName = '02:00 AM'
		if(timeName == '03:00') timeName = '03:00 AM'
		if(timeName == '04:00') timeName = '04:00 AM'
		if(timeName == '05:00') timeName = '05:00 AM'
		if(timeName == '06:00') timeName = '06:00 AM'
		if(timeName == '07:00') timeName = '07:00 AM'
		if(timeName == '08:00') timeName = '08:00 AM'
		if(timeName == '09:00') timeName = '09:00 AM'
		if(timeName == '10:00') timeName = '10:00 AM'
		if(timeName == '11:00') timeName = '11:00 AM'
		if(timeName == '12:00') timeName = '12:00 PM'
		if(timeName == '13:00') timeName = '01:00 PM'
		if(timeName == '14:00') timeName = '02:00 PM'
		if(timeName == '15:00') timeName = '03:00 PM'
		if(timeName == '16:00') timeName = '04:00 PM'
		if(timeName == '17:00') timeName = '05:00 PM'
		if(timeName == '18:00') timeName = '06:00 PM'
		if(timeName == '19:00') timeName = '07:00 PM'
		if(timeName == '20:00') timeName = '08:00 PM'
		if(timeName == '21:00') timeName = '09:00 PM'
		if(timeName == '22:00') timeName = '10:00 PM'
		if(timeName == '23:00') timeName = '11:00 PM'
		return timeName
	},
	toDecimal: (x) =>{
		var f = parseFloat(x);    
        if (isNaN(f)) {    
            return false;    
        }    
        var f = Math.round(x*100)/100;    
        var s = f.toString();    
        var rs = s.indexOf('.');    
        if (rs < 0) {    
            rs = s.length;    
            s += '.';    
        }    
        while (s.length <= rs + 2) {    
            s += '0';    
        }    
        return s; 
	},
	getDifference: () =>{
		let difference = 0
		
		let userInfo = JSON.parse(window.localStorage.getItem("userInfo")).store
		if(userInfo){
			difference = userInfo.difference
		}else{
			difference = 0
		}
		return difference
	}
}





// WEBPACK FOOTER //
// ./src/assets/js/common.js